module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.8717/img/business-types/ecommerce.png"